<nav class="flex flex-col h-full max-h-screen transition-colors duration-300 overflow-y-auto overflow-x-hidden bg-scheme "
  [ngClass]="[
    drawerConfig.collapse ? 'collpased' : 'expanded'
  ]" (mouseenter)="onDrawerMouseEnter()" (mouseleave)="onDrawerMouseLeave($event)">
  <!-- Header -->

  <div class="sticky top-0 z-10">
    <header class="fix  flex flex-row items-center justify-between px-2 py-1 bg-scheme" >
      <!-- Top Left Button -->
      @if (!drawerConfig.collapse) {
      <button (click)="toggleCopilot()"
        class="flex items-center justify-center p-2 rounded-md transition-colors duration-200" mat-icon-button
        matTooltipPosition='right' matTooltip="Go To Drive" aria-label="Go To Drive">
        <mat-icon class="icon-size-5 transition-opacity duration-200" svgIcon="feather:folder"></mat-icon>
      </button>
  
      <!-- Toggle Button -->
      <button (click)="onDrawerToggle()"
        class="flex items-center justify-center p-2 rounded-md transition-colors duration-200" mat-icon-button
        matTooltipPosition='right' [matTooltip]="drawerConfig.collapse? 'Expand sidebar' : 'Collapse sidebar'"
        aria-label="Toggle Sidebar">
        <mat-icon class="icon-size-5 transition-opacity duration-200" [svgIcon]="'dms-custom:sidebar-toggle'"></mat-icon>
      </button>
      }
      @else {
      <button *ngIf="!isHovering" (click)="startNewChat()"
        class="flex items-center justify-center p-2 rounded-md transition-colors duration-200" mat-icon-button
        matTooltipPosition='right' matTooltip="New Chat" aria-label="New Chat">
        <mat-icon class="icon-size-5 transition-opacity duration-200" svgIcon="feather:cpu"></mat-icon>
      </button>
  
      <button *ngIf="isHovering" (click)="onDrawerToggle()"
        class="flex items-center justify-center p-2 rounded-md transition-colors duration-200" mat-icon-button
        matTooltipPosition='right' [matTooltip]="drawerConfig.collapse? 'Expand sidebar' : 'Collapse sidebar'"
        aria-label="Toggle Sidebar">
        <mat-icon class="icon-size-5 transition-opacity duration-200" [svgIcon]="'dms-custom:sidebar-toggle'"></mat-icon>
      </button>
      }
  
    </header>
  
    <!-- Aside (New Chat + Search) -->
    <aside class="fix flex flex-col items-center gap-1 py-1 bg-scheme"
      >
      <!-- New Chat -->
      @if (drawerConfig.collapse) {
      <button (click)="startNewChat()" class="flex items-center justify-center rounded-md transition-colors duration-200"
        mat-icon-button matTooltipPosition='right' matTooltip="New Chat" aria-label="New Chat">
        <mat-icon class="icon-size-5 transition-opacity duration-200"
          svgIcon="heroicons_outline:pencil-square"></mat-icon>
      </button>
      }
      @else {
      <button (click)="startNewChat()"
        class="w-full mx-2 flex items-center justify-start  py-1 text-sm font-medium transition-colors duration-200 !rounded-md hover:!rounded-md"
        mat-button matTooltipPosition='right' matTooltip="New Chat" aria-label="New Chat">
        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:pencil-square"></mat-icon>
        <span class="ml-2">New chat</span>
      </button>
      }
  
      <!-- Search Chats -->
      @if (drawerConfig.collapse) {
      <button (click)="openSearchChat()" class="flex items-center justify-center rounded-md transition-colors duration-200"
        mat-icon-button matTooltipPosition='right' matTooltip="Search Chats" aria-label="Search Chats">
        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
      </button>
      }
      @else {
        <button
        (click)="openSearchChat()"
        class="w-full mx-2 flex items-center justify-start  py-1 text-sm font-medium transition-colors duration-200 !rounded-md hover:!rounded-md"
        mat-button
        matTooltipPosition="right"
        matTooltip="Search Chats"
        disableRipple
      >
        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
        <span *ngIf="!drawerConfig.collapse" class="ml-2">Search chats</span>
      </button>
      
      }
    </aside>
  </div>

  <!-- Chats Section -->
  <div *ngIf="!drawerConfig.collapse" class="flex-1 space-y-1 px-2 pb-4">
    <h3 class="px-2 py-2 text-xs uppercase tracking-wide opacity-60">Chats</h3>
    <ng-container *ngFor="let session of sessions">
      <div *ngIf="session.sessionName"  (click)="selectSession(session)"
      class="group relative flex flex-row items-center px-3 py-2 rounded-lg cursor-pointer transition-colors duration-200 "
      [ngClass]="[
        session.id === selectedSessionId
              ? 'bg-hover font-semibold border border-primary'
              : 'hover:bg-hover hover:text-hover-foreground'
      ]" [title]="session.sessionName">
      <div class="text-sm font-medium truncate transition-all duration-150" [ngClass]="{
          'font-semibold': session.id === selectedSessionId,
          'pr-8': selectedMenuSessionId === session.id,
          'group-hover:pr-8': selectedMenuSessionId !== session.id
        }">
        {{ session.sessionName }}
      </div>

      <!-- Session Menu -->
      <div class="absolute right-2 top-1/2 -translate-y-1/2 transition-opacity duration-150" [ngClass]="{
          'opacity-100': selectedMenuSessionId === session.id,
          'opacity-0 group-hover:opacity-100': selectedMenuSessionId !== session.id
        }">
        <button (click)="$event.stopPropagation()" (menuOpened)="selectedMenuSessionId = session.id"
          (menuClosed)="selectedMenuSessionId = null" class="list-item-inline-action-menu my-1 clean-icon-btn"
          mat-icon-button matTooltipPosition='right' matTooltip="Menu" disableRipple [matMenuTriggerFor]="menu">
          <mat-icon class="icon-size-4 font-bold" [svgIcon]="'heroicons_solid:ellipsis-vertical'"></mat-icon>
        </button>
      </div>

      <!-- Menu Items -->
      <mat-menu #menu="matMenu" class="session-menu">
        <button mat-menu-item (click)="shareSession(session)">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:share"></mat-icon>
          <span>Share</span>
        </button>
        <button mat-menu-item (click)="renameSession(session)">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:pencil-square"></mat-icon>
          <span>Rename</span>
        </button>
        <button mat-menu-item (click)="archiveSession(session)">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:archive-box-arrow-down"></mat-icon>
          <span>Archive</span>
        </button>
        <button mat-menu-item
          class="flex items-center gap-2 rounded-md text-red-500 hover:bg-red-100 transition-colors duration-200"
          (click)="deleteSession(session)">
          <mat-icon class="icon-size-4 text-red-500" svgIcon="heroicons_outline:trash"></mat-icon>
          <span class="text-red-500">Delete</span>
        </button>
      </mat-menu>
    </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="sticky bottom-0 z-10 mt-auto border-t p-3 bg-scheme dark:border-white/10 border-gray-200">
    <div class="flex items-center gap-2" [ngClass]="drawerConfig.collapse ? 'flex-col' : 'flex-row'">
      <button matTooltipPosition='right' [matTooltip]="userDetail.name" [matMenuTriggerFor]="menu" matTooltipPosition="right" class="flex items-center justify-center w-8 h-8 rounded-full cursor-pointer shadow-md transition-all
               bg-primary text-white font-medium hover:opacity-90
               disabled:cursor-not-allowed disabled:opacity-40">
        {{ userDetail.name.charAt(0).toUpperCase() }}
      </button>

      @if (!drawerConfig.collapse) {
      <div class="text-sm font-medium">{{ userDetail.name }}</div>
      }
    </div>

    <!-- User Menu -->
    <mat-menu #menu="matMenu" class="session-menu">
      <div class="flex items-center gap-2 px-2 py-1 text-sm font-medium text-gray-600">
        <mat-icon class="icon-size-5 text-gray-400" svgIcon="heroicons_outline:user-circle"></mat-icon>
        {{ userDetail.email }}
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item>
        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:sparkles"></mat-icon>
        <span>Upgrade Plan</span>
      </button>

      <button mat-menu-item>
        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:adjustments-horizontal"></mat-icon>
        <span>Customize</span>
      </button>

      <button mat-menu-item>
        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:cog-8-tooth"></mat-icon>
        <span>Settings</span>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item>
        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:question-mark-circle"></mat-icon>
        <span>Help</span>
      </button>

    </mat-menu>
  </div>
</nav>